

import React, { useEffect } from "react";
import { Modal } from "antd";
import { useSelector } from "react-redux";  

const PopupUI = ({ popupContent, isAdd, isUpdate, handleClose, title , isOpen ,width}) => {
  const mode = useSelector((state) => state.darkMode);

  const { isdarkMode } = mode;

    const theme = isdarkMode
    console.log(theme)
      const color = useSelector((state) => state.ThemeChange);
        console.log(color)
  return (
    <Modal
      // title={<p className="font-bold bg-red-500 p-3 ">{title}</p>} 
      open={isAdd || isUpdate }
      onCancel={handleClose}
      footer={null}
      className={`custom-modal  ${isdarkMode ? " group-custom-modal-dark  group-custom-modal-header group-labels group-input group-select-input-background " : "whitemode"} `}
      width={width||1000}
    
    >
       <div
          className={`text-white text-lg font-bold text-center py-3 ${
            theme ? " text-white" : ""
          }  -mt-6 rounded-t-lg mb-0`}
          style={{ backgroundColor:  color.themeConfig.colorPrimaryHover}}
        >
          Enter Data
        </div>
      <div className="form-input-details space-y-2  flex justify-center border p-3 px-8 rounded-b-xl ">
        {popupContent}
      </div>
    </Modal>
  );
};

export default PopupUI;










